/* eslint-disable jsx-a11y/anchor-has-content */
import { useTranslation } from "react-i18next";
import { Container } from "./Footer.style";
import { Link } from "react-router-dom";

import Logo from "../../Assets/LogoWhite.svg";
import Selo from "../../Assets/Images/Selo.png";

import { BsFacebook, BsInstagram, BsYoutube } from "react-icons/bs";
import { FaTiktok } from "react-icons/fa";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <Container>
      <footer className="footer" id="Contact">
        <div className="containerFooter">
          <div className="container-top">
            <div className="container-information">
              <div className="container-baba">
                <img src={Logo} alt="" />
                <p>{t("footer.profName")}</p>

                <div className="social">
                  <p>{t("footer.socialLabel")}</p>
                  <div className="icons">
                    <a target="blank" href="https://www.facebook.com/babakingoduduwa/" aria-label="Facebook do Bàbá King"><BsFacebook size={40} className="face" /></a>
                    <a target="blank" href="https://www.instagram.com/babakingoduduwa/" aria-label="Instagram do Bàbá King"><BsInstagram size={40} className="insta" /></a>
                    <a target="blank" href="https://www.tiktok.com/@babakingoduduwa" aria-label="TikTok do Bàbá King"><FaTiktok size={40} className="tik" /></a>
                    <a target="blank" href="https://www.youtube.com/OduduwaTemplodosOrixas/" aria-label="Youtube do Oduduwa"><BsYoutube size={40} className="you" /></a>
                  </div>
                </div>
              </div>

              <img className="selo" src={Selo} alt="" />
            </div>

            <div className="websites">
              <p>{t("footer.world")}</p>
              <a href="https://oduduwa.com.br/" aria-label="Sitio de Oduduwa Brasil" target="_blank" rel="noreferrer">Oduduwa Brasil</a>
              <a href="https://oduduwacursos.com.br/" aria-label="Sitio de Oduduwa Cursos" target="_blank" rel="noreferrer">Oduduwa Cursos</a>
              <a href="https://oduduwa-nigeria.com/" aria-label="Sitio de Oduduwa Nigeria" target="_blank" rel="noreferrer">Oduduwa Nigeria</a>
              <a href="https://www.oduduwa-europe.com/" aria-label="Sitio de Oduduwa Europe" target="_blank" rel="noreferrer">Oduduwa Europe</a>
              <a href="https://orisa.si/en/dance-of-the-orisa/#" aria-label="Sitio de Òrìṣà" target="_blank" rel="noreferrer">{t("footer.orisa")}</a>
            </div>
          </div>

          <div className="container-bottom">
            <p>{t("footer.copyright")} {new Date().getFullYear()}. {t("footer.copyright.pt2")}</p>
            <Link target="blank" to="/politica-de-privacidade" className="privacy">
              {t("footer.privacy")}
            </Link>
          </div>
        </div>
      </footer>
    </Container>
  );
}
